import React from "react";
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
} from "@/components/ui/sheet";
import ScoringForm from "@/features/scoring/components/ScoringForm";

/**
 * Wraps ScoringForm inside a bottom sheet (mobile) or right sheet (desktop).
 * `item` shape mirrors what ScoringForm expects on /today:
 *   { task, activity, outcome, individual_id, measurement_id? }
 */
const ScoringSheet = ({ open, onOpenChange, item, readOnly, onSaved }) => {
    return (
        <Sheet open={open} onOpenChange={onOpenChange}>
            <SheetContent
                side="bottom"
                data-testid="history-scoring-sheet"
                className="h-[92dvh] overflow-y-auto sm:h-auto sm:max-h-[92dvh] sm:right-0 sm:left-auto sm:top-0 sm:bottom-0 sm:w-full sm:max-w-2xl sm:border-l sm:border-t-0"
            >
                <SheetHeader className="mb-3">
                    <SheetTitle className="text-left text-lg font-bold">
                        {readOnly ? "View entry" : "Score task"}
                    </SheetTitle>
                </SheetHeader>
                {item && (
                    <ScoringForm
                        item={item}
                        readOnly={readOnly}
                        onSaved={() => {
                            onOpenChange(false);
                            onSaved?.();
                        }}
                        onSkip={() => onOpenChange(false)}
                    />
                )}
            </SheetContent>
        </Sheet>
    );
};

export default ScoringSheet;
